import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=9d5e53e6&"
import script from "./InputSwitch.vue?vue&type=script&lang=js&"
export * from "./InputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=9d5e53e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports